import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SubscriberEntryPoint, UpsellPanelContent, UserAccessLevelType } from "../../../constants/upsellPanelEnumsAndConstants";
import { useRouteInitialData } from "../../../hooks/useRouteInitialData";
import useUpsellBaseModel from "./useUpsellBaseModel";

const useArticlePopupModel = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const uType = params.get('utype');
    const { requiredAccessLevel, trackingClass } = useRouteInitialData();
    const baseModel = useUpsellBaseModel();
    const getMobileText = useMemo(() => {
        return requiredAccessLevel == UserAccessLevelType.IntelligentInvestor ?
            "Unlock this article & all Intelligent Investor content. ASX Stock Buy, Hold & Sell recommendations, Model Portfolios, Podcasts & Special Reports."
            : "Unlock this article & all Eureka Report content. CEO Interviews and of course Alan Kohler’s Weekend Brief and more";

    }, [requiredAccessLevel])

    const getContentParagraph2 = useMemo(() => {
        if (requiredAccessLevel == UserAccessLevelType.Professional) {
            return "Unlock this article & all Intelligent Investor content. ASX Stock Buy, Hold, Sell recommendations, Model Portfolios, Podcasts and more";
        } else if (requiredAccessLevel == UserAccessLevelType.IntelligentInvestor) {
            return "Unlock this article & all Intelligent Investor content. ASX Stock Buy, Hold, Sell recommendations, Model Portfolios, Podcasts and more";
        } else {
            return "Unlock this article & all Eureka Report content. CEO Interviews and of course Alan Kohler’s Weekend Brief and more";
        }
    }, [requiredAccessLevel])

    const content = {
        ...baseModel.content,
        //contentParagraph2: getContentParagraph2,
        trialHeading: UpsellPanelContent.UPSELL_TRIAL_HEADING,
        upgradeHeading: UpsellPanelContent.FREE_15_DAY_TRIAL,
        loginParagraph: ""
    };

    const model = useMemo(() => {
        return {
            ...baseModel,
            content,
            entryPoint: SubscriberEntryPoint.TRIAL_ARTICLE,
            entryPointTrial: SubscriberEntryPoint.TRIAL_ARTICLE,
            mainButtonText: UpsellPanelContent.CREATE_YOUR_FREE_ACCOUNT,
            mobileRequired: false,
            mobileText: getMobileText,
            passwordRequired: true,
            question: UpsellPanelContent.FREE_TRIAL_15_DAY,
            trackingClass,
            uType,
        };
    }, []);

    return model;
};
export default useArticlePopupModel;
